<app-content-grid [allowDelete]="true"></app-content-grid>